export const MASTERMULTICINEMA = 'multiClient'
export const MASTERMULTITOTAL = 'multiTotal'